import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SearchListIcon = React.forwardRef(function SearchListIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M1 3H19C19.55 3 20 2.55 20 2 20 1.45 19.55 1 19 1H1C.45 1 0 1.45 0 2 0 2.55.45 3 1 3ZM1 9H4C4.55 9 5 8.55 5 8 5 7.45 4.55 7 4 7H1C.45 7 0 7.45 0 8 0 8.55.45 9 1 9ZM1 15H3C3.55 15 4 14.55 4 14 4 13.45 3.55 13 3 13H1C.45 13 0 13.45 0 14 0 14.55.45 15 1 15ZM6 19H1C.45 19 0 19.45 0 20 0 20.55.45 21 1 21H6C6.55 21 7 20.55 7 20 7 19.45 6.55 19 6 19ZM23.71 21.29 19.71 17.29C19.71 17.29 19.62 17.24 19.58 17.21 20.47 16.04 21 14.58 21 13 21 9.14 17.86 6 14 6 10.14 6 7 9.14 7 13 7 16.86 10.14 20 14 20 15.58 20 17.04 19.47 18.21 18.58 18.24 18.62 18.26 18.67 18.29 18.71L22.29 22.71C22.49 22.91 22.74 23 23 23 23.26 23 23.51 22.9 23.71 22.71 24.1 22.32 24.1 21.69 23.71 21.3V21.29ZM14 18C11.24 18 9 15.76 9 13 9 10.24 11.24 8 14 8 16.76 8 19 10.24 19 13 19 15.76 16.76 18 14 18Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

SearchListIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SearchListIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SearchListIcon
